module.exports = __webpack_public_path__ + "static/media/19ESCAP31.76027418.jpg";